<script>
import ImageCollectorHelper from '@/Scripts/lib/helper/imageCollectorHelper.js';
import GetSizes from '@/Scripts/lib/helper/imageSizesHelper.js';

import { PROPORTIONS } from '@/Scripts/constants';

export default {
  props: {
    model: Object,
    datatype: String,
    sizes: {
      type: String,
      default: '100vw'
    },
    proportions: {
      type: Object,
      default () {
        return {
          SM: PROPORTIONS.DEFAULT.SM,
          MD: PROPORTIONS.DEFAULT.MD,
          LG: PROPORTIONS.DEFAULT.LG
        };
      }
    },
    autoProportion: Boolean,
    transparent: Boolean,
    fallBackSlide: Object,
    forceLandscapeVideo: Boolean,
    specialRules: Object
  },
  data () {
    return {
      rearrangeCounter: 0
    };
  },
  computed: {
    isMobile () {
      return this.$mqAliases.xs || this.$mqAliases.sm;
    },
    responsiveModels () {
      const data = {
        desktop: {
          Media: []
        },
        mobile: {
          Media: []
        }
      };
      if (!this.model || !this.model.Media) {
        return data;
      }
      const media = [...this.model.Media];
      for (let i = 0; i < media.length; i++) {
        const item = media[i];
        let foundPair = false;
        if (item.PairingId) {
          const pair = media.splice(media.findIndex(obj => obj.PairingId === item.PairingId && obj.Id !== item.Id && !obj.isPaired), 1);
          if (pair && pair.length) {
            const itemAsDekstop = item.Width / item.Height > pair[0].Width / pair[0].Height;
            data.desktop.Media.push(itemAsDekstop ? item : pair[0]);
            data.mobile.Media.push(itemAsDekstop ? pair[0] : item);
            foundPair = true;
          }
        }
        if (!foundPair) {
          data.desktop.Media.push(item);
          data.mobile.Media.push(item);
        }
      }
      return data;
    },
    currentModel () {
      if (this.$mqAliases.desktop || this.forceLandscapeVideo) {
        return this.responsiveModels.desktop;
      }
      return this.responsiveModels.mobile;
    },

    // use passed inn proportions with breakpoints
    responsiveProportion () {
      if (this.isMobile) {
        return this.proportions.SM;
      } else if (this.$mqAliases.md) {
        return this.proportions.MD;
      }
      return this.proportions.LG;
    },
    getProportion () {
      if (this.currentModel && this.autoProportion) {
        // calcultate proportion based on smalles media height
        let prop = 100000000;
        for (let i = 0; i < this.currentModel.Media.length; i++) {
          const tempprop = this.currentModel.Media[0].Width / this.currentModel.Media[0].Height;
          if (tempprop && tempprop > 0 && tempprop < prop) {
            prop = tempprop;
          }
        }
        return prop;
      } else if (this.fallBackSlide && this.fallBackSlide.width > 0 && this.fallBackSlide.height > 0) {
        // if fallback media is used
        return this.fallBackSlide.width / this.fallBackSlide.height;
      }
      // or use passed in proportions
      return this.responsiveProportion;
    },
    media () {
      const media = [...this.currentModel.Media];
      if (this.specialRules && this.specialRules.type === 'icsort') {
        media.forEach(item => {
          const order = item.ImageTags.find(t => t.includes('orderweight'));
          const col2 = item.ImageTags.find(t => t === '2colgridview');
          const col3 = item.ImageTags.find(t => t === '3colgridview');
          const whitebutton = item.ImageTags.find(t => t === 'whitebutton');
          const blackbutton = item.ImageTags.find(t => t === 'blackbutton');
          if (whitebutton) {
            item.styling = 'whitebutton';
          }
          if (blackbutton) {
            item.styling = 'blackbutton';
          }
          if (order) {
            item.order = parseInt(order.replace('orderweight', ''));
          }
          if (col2) {
            item.col2 = true;
          } else if (col3) {
            item.col3 = true;
          }
        });
        media.sort((a, b) => a.order - b.order);
      }

      return media;
    },
    slides () {
      if (this.currentModel) {
        const list = [];
        const bgcolor = this.transparent ? 'transparent' : null;
        if (this.media) {
          this.media.forEach((item, index) => {
            if (item.col2) {
              list.push(this.makeCol2Slide(item));
            } else if (item.col3) {
              list.push(this.makeCol3Slide(item));
            } else {
              list.push(ImageCollectorHelper.buildMediaObject(item, item.col2 ? 1 : this.getProportion, this.sizes, bgcolor));
            }
          });
        } else {
          console.warn('No media in block', this.currentModel);
        }

        return list;
      } else if (this.fallBackSlide) {
        return [
          this.fallBackSlide
        ];
      }
      return [];
    }
  },
  methods: {
    makeCol2Slide (item) {
      const slide = ImageCollectorHelper.buildMediaObject(item, 1, GetSizes([{ cols: 1, breakPoint: 'MD' }, { cols: 1, breakPoint: 'LG' }]));
      slide.gridSpan = 8;
      slide.proportion = 1;
      return slide;
    },
    makeCol3Slide (item) {
      const slide = ImageCollectorHelper.buildMediaObject(item, 1.6, GetSizes([{ cols: 1, breakPoint: 'MD' }, { cols: 1, breakPoint: 'LG' }]));
      slide.gridSpan = 12;
      slide.proportion = 1.6;
      return slide;
    }
  },
  render () {
    // return data and methods to the v-slot in parent template
    return this.$scopedSlots.default({
      slides: this.slides,
      proportion: this.getProportion
    });
  }
};
</script>
